import { render } from "./DataGridDrilldown.vue?vue&type=template&id=296c0e47&ts=true"
import script from "./DataGridDrilldown.vue?vue&type=script&lang=ts"
export * from "./DataGridDrilldown.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__